import McGateway from './McGateway';
export { McGateway };
